import { isEmpty, find, isUndefined, isArrayLikeObject, isArrayLike, isFinite, sum } from 'lodash';
/* eslint no-bitwise: 0 */

export function getDescriptionData(description) {
    return isEmpty(description) ? '' : description[0];
}

export function getModelTrimsBitField(trimsBitFieldsData) {
    const modelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: [],
    };
    if (!isArrayLike(trimsBitFieldsData) && !isFinite(trimsBitFieldsData)) {
        return modelTrimsBitField;
    }

    if (isArrayLike(trimsBitFieldsData)) {
        if (trimsBitFieldsData.length === 1) {
            modelTrimsBitField.trimsBitField = trimsBitFieldsData[0];
        } else {
            modelTrimsBitField.trimsBitFields = trimsBitFieldsData;
        }
    } else {
        modelTrimsBitField.trimsBitField = trimsBitFieldsData;
    }
    return modelTrimsBitField;
}

export function getBaseSelectionObject(trimFlag, selectionCode) {
    const { trimsBitField, trimsBitFields } = getModelTrimsBitField(trimFlag);
    return {
        trimsBitField,
        trimsBitFields,
        selectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
    };
}

export function getSelectionObject(trimFlag, selectionCode, code, description) {
    const selectionObj = getBaseSelectionObject(trimFlag, selectionCode);
    selectionObj.code = code;
    selectionObj.description = getDescriptionData(description);

    return selectionObj;
}

export function getDataObject(dataItem, flagIndex, descriptionIndex) {
    let dataObject = {};

    if (isEmpty(dataItem)) {
        return dataObject;
    }

    const code = getDescriptionData(dataItem[descriptionIndex]);
    dataObject = getSelectionObject(dataItem[flagIndex], code, code, dataItem[descriptionIndex]);

    return dataObject;
}

export function getIncentiveExpirationDays(incentiveExpirationDate) {
    const today = new Date();
    let expirationDays = 30;
    if (incentiveExpirationDate) {
        const expirationConvertedDate = new Date(incentiveExpirationDate);
        if (expirationConvertedDate > today) {
            let expirationMonth = expirationConvertedDate.getMonth();
            if (today.getFullYear() < expirationConvertedDate.getFullYear()) {
                expirationMonth += 12;
            }

            let expirationDay = expirationConvertedDate.getDate();
            if (today.getMonth() < expirationMonth) {
                expirationDay += 30;
            }

            expirationDays = expirationDay - today.getDate() + 1;
        }
    }

    return expirationDays;
}

export function mergeModelTrimsBitField(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB, orOperation) {
    const mergedModelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: [],
    };
    if (isUndefined(modelTrimsBitFieldObjectA.trimsBitField) || isUndefined(modelTrimsBitFieldObjectB.trimsBitField)) {
        return mergedModelTrimsBitField;
    }

    if (modelTrimsBitFieldObjectA.trimsBitField || modelTrimsBitFieldObjectB.trimsBitField) {
        mergedModelTrimsBitField.trimsBitField = orOperation
            ? modelTrimsBitFieldObjectA.trimsBitField | modelTrimsBitFieldObjectB.trimsBitField
            : modelTrimsBitFieldObjectA.trimsBitField & modelTrimsBitFieldObjectB.trimsBitField;
        return mergedModelTrimsBitField;
    }

    const emptyObjectA = isEmpty(modelTrimsBitFieldObjectA.trimsBitFields);
    const emptyObjectB = isEmpty(modelTrimsBitFieldObjectB.trimsBitFields);
    if (orOperation && (emptyObjectA || emptyObjectB)) {
        if (emptyObjectA && emptyObjectB) {
            return mergedModelTrimsBitField;
        }
        mergedModelTrimsBitField.trimsBitFields = emptyObjectA
            ? modelTrimsBitFieldObjectB.trimsBitFields
            : modelTrimsBitFieldObjectA.trimsBitFields;

        return mergedModelTrimsBitField;
    } else if (
        emptyObjectA ||
        emptyObjectB ||
        modelTrimsBitFieldObjectA.trimsBitFields.length !== modelTrimsBitFieldObjectB.trimsBitFields.length
    ) {
        return mergedModelTrimsBitField;
    }

    for (let i = 0; i < modelTrimsBitFieldObjectA.trimsBitFields.length; i += 1) {
        mergedModelTrimsBitField.trimsBitFields.push(
            orOperation
                ? modelTrimsBitFieldObjectA.trimsBitFields[i] | modelTrimsBitFieldObjectB.trimsBitFields[i]
                : modelTrimsBitFieldObjectA.trimsBitFields[i] & modelTrimsBitFieldObjectB.trimsBitFields[i]
        );
    }
    return mergedModelTrimsBitField;
}

export function intersectModelTrimsBitFieldValue(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB) {
    const mergedModelTrimsBitField = mergeModelTrimsBitField(
        modelTrimsBitFieldObjectA,
        modelTrimsBitFieldObjectB,
        false
    );

    if (isEmpty(mergedModelTrimsBitField.trimsBitFields)) {
        return mergedModelTrimsBitField.trimsBitField;
    }

    return sum(mergedModelTrimsBitField.trimsBitFields);
}

export function getObjectFromAvailabilityFlag(objectList, availabilityBitField) {
    let availableObject = null;

    if (
        isEmpty(objectList) ||
        !isArrayLikeObject(objectList) ||
        (!availabilityBitField.trimsBitField && isEmpty(availabilityBitField.trimsBitFields))
    ) {
        return availableObject;
    }

    availableObject = find(objectList, (item) => {
        return intersectModelTrimsBitFieldValue(item, availabilityBitField) > 0;
    });

    return isUndefined(availableObject) ? null : availableObject;
}

export default {
    getDescriptionData,
    getBaseSelectionObject,
    getSelectionObject,
    getDataObject,
    getObjectFromAvailabilityFlag,
    getIncentiveExpirationDays,
    getModelTrimsBitField,
    mergeModelTrimsBitField,
    intersectModelTrimsBitFieldValue,
};



// WEBPACK FOOTER //
// ./src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js